export default function digits() {
    return {
        validate(input) {
            return { valid: (input.value === '') || /^\d+$/.test(input.value) };
        },
    };
}



// WEBPACK FOOTER //
// ./app/webpack/vendor/formvalidation-1.3.0/dist/es6/validators/digits.js